import {IdTokenResult} from 'firebase/auth';
import { auth } from '../firebase';


export class ProfileService {

  public static async isAdmin(): Promise<boolean> {
    if (!auth.currentUser) {
      return false;
    }
    const idTokenResult: IdTokenResult = await auth.currentUser.getIdTokenResult();
    return !!idTokenResult.claims.admin || !!idTokenResult.claims.isAdmin;
  }
}
